import {
  OBSERVADOR_INICIALITZAR,
  OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
  OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnviarFormulariEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case OBSERVADOR_INICIALITZAR:
      return ESTAT_INICIAL;

    case OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS:
      return true;

    case OBSERVADOR_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA:
      return false;

    default:
      return state;
  }
};

export default peticioEnviarFormulariEnCurs;
